if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          const html = this.innerHTML;
          const form = document.createElement('form');
          form.setAttribute('id', 'product_form_' + this.dataset.sectionId);
          form.setAttribute('action', routes.cart_add_url);
          form.setAttribute('method', 'post');
          form.setAttribute('enctype', 'multipart/form-data');
          form.setAttribute('novalidate', 'novalidate');
          form.setAttribute('data-type', 'add-to-cart-form');
          form.setAttribute('data-section-id', this.dataset.sectionId);
          form.innerHTML = html;
          this.innerHTML = '';
          this.appendChild(form);
          this.form = form;
        }
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // Don't find cart element in constructor - find it dynamically
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Find cart element dynamically
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        // Debug: Log cart element info
        console.log('Cart element found:', this.cart);
        console.log('Cart element tagName:', this.cart ? this.cart.tagName : 'null');
        console.log('All cart-drawer elements:', document.querySelectorAll('cart-drawer'));
        console.log('All cart-notification elements:', document.querySelectorAll('cart-notification'));
        console.log('Cart drawer HTML:', document.querySelector('cart-drawer') ? document.querySelector('cart-drawer').outerHTML.substring(0, 200) : 'Not found');
        console.log('Document ready state:', document.readyState);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('No cart element found, trying to find cart drawer...');
              console.log('Available cart-drawer elements:', document.querySelectorAll('cart-drawer'));
              console.log('Available cart-notification elements:', document.querySelectorAll('cart-notification'));

              // Try to find cart drawer with a delay
              setTimeout(() => {
                const delayedCartDrawer = document.querySelector('cart-drawer');
                if (delayedCartDrawer) {
                  console.log('Found cart drawer with delay, rendering contents...');
                  delayedCartDrawer.renderContents(response);
                  delayedCartDrawer.open();
                } else {
                  console.log('Still no cart drawer found, redirecting to cart page');
                  window.location = window.routes.cart_url;
                }
              }, 200);
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);

                      // Try to find cart drawer again in case it wasn't found initially
                      const cartDrawer = document.querySelector('cart-drawer');
                      console.log('QuickAdd - Cart element:', this.cart);
                      console.log('QuickAdd - Cart tagName:', this.cart ? this.cart.tagName : 'null');
                      console.log('QuickAdd - Cart drawer found:', cartDrawer);
                      console.log('QuickAdd - Cart drawer tagName:', cartDrawer ? cartDrawer.tagName : 'null');
                      console.log('QuickAdd - Cart drawer has open method:', cartDrawer && typeof cartDrawer.open === 'function');

                      // Try to open cart drawer - use the found cart drawer or fallback to this.cart
                      const targetCart = cartDrawer || this.cart;
                      if (targetCart && targetCart.tagName === 'CART-DRAWER') {
                        console.log('QuickAdd - Opening cart drawer...');
                        targetCart.open();
                      } else {
                        console.log('QuickAdd - Cart drawer not found or not a cart-drawer element');
                        console.log('QuickAdd - Target cart:', targetCart);

                        // Fallback: try to find and open cart drawer with a small delay
                        setTimeout(() => {
                          const delayedCartDrawer = document.querySelector('cart-drawer');
                          if (delayedCartDrawer && typeof delayedCartDrawer.open === 'function') {
                            console.log('QuickAdd Fallback: Opening cart drawer with delay...');
                            delayedCartDrawer.open();
                          } else {
                            console.log('QuickAdd Fallback: Still no cart drawer found');
                          }
                        }, 100);
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);

                // Try to find cart drawer again in case it wasn't found initially
                const cartDrawer = document.querySelector('cart-drawer');
                console.log('Success - Cart element:', this.cart);
                console.log('Success - Cart tagName:', this.cart ? this.cart.tagName : 'null');
                console.log('Success - Cart drawer found:', cartDrawer);
                console.log('Success - Cart drawer tagName:', cartDrawer ? cartDrawer.tagName : 'null');
                console.log('Success - Cart drawer has open method:', cartDrawer && typeof cartDrawer.open === 'function');

                // Try to open cart drawer - use the found cart drawer or fallback to this.cart
                const targetCart = cartDrawer || this.cart;
                if (targetCart && targetCart.tagName === 'CART-DRAWER') {
                  console.log('Opening cart drawer...');
                  targetCart.open();
                } else {
                  console.log('Cart drawer not found or not a cart-drawer element');
                  console.log('Target cart:', targetCart);

                  // Fallback: try to find and open cart drawer with a small delay
                  setTimeout(() => {
                    const delayedCartDrawer = document.querySelector('cart-drawer');
                    if (delayedCartDrawer && typeof delayedCartDrawer.open === 'function') {
                      console.log('Fallback: Opening cart drawer with delay...');
                      delayedCartDrawer.open();
                    } else {
                      console.log('Fallback: Still no cart drawer found');
                    }
                  }, 100);
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) {
              spinner.classList.add('hidden');
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
